import {
  initReport,
  initReportMultiDataSource,
  serializeQuery,
} from "helpers/service_helper"
import { CityFromSection } from "hooks/returnCityName"
import React, { useState, useEffect } from "react"
import { Button, Row, Col, Spin, Switch, Space } from "antd"
import { connect } from "react-redux"

import StiReport from "../../../../assets/reports/finance/FinanceForEng.mrt"

import Localizations from "../../../../locales/fa/fa.xml"
import { FinanceReportList } from "./finance-report-list"
import { getFinanceReport, getFinanceReportDetailList } from "store/actions"
import { approved } from "services/finance/approved"
import { loadStimulsoftScripts } from "helpers/stimulsoftLoader"
const Report = props => {
  const {
    onGetFinanceReportDetailList,
    lstFinanceReportDetail,
    lstFinanceReport,
    loading,
    openNotification,
  } = props
  const [errorMessage, setErrorMessage] = useState(null)

  const [financeReportId, setFinanceReportId] = useState(null)
  const [financeDataApproved, setFinanceDataApproved] = useState(null)
  const [insideLoading, setInsideLoading] = useState(false)

  // Helper to ensure Stimulsoft scripts are loaded before using initReport
  const ensureStimulsoftAndInit = async (reportData, groupReport) => {
    await loadStimulsoftScripts()

    initReportMultiDataSource(StiReport, reportData, Localizations, {
      amir: "amir",
      test: 122,
    })
  }

  useEffect(() => {
    setTimeout(() => {
      setErrorMessage(null)
    }, 3000)
  }, [errorMessage])

  useEffect(() => {
    // props.onGetListExecutor()
    if (lstFinanceReportDetail.length > 0) {
      const reportData = {
        FinanceData: lstFinanceReport?.filter(x => x.id === financeReportId),
        FinanceList: lstFinanceReportDetail,
      }
      setInsideLoading(false)
      ensureStimulsoftAndInit(reportData, 0)
    }
  }, [lstFinanceReportDetail])

  useEffect(async () => {
    if (financeReportId) {
      setFinanceDataApproved(
        lstFinanceReport?.filter(x => x.id === financeReportId)[0].approved
      )
      await prepareReport()
    }
  }, [financeReportId, lstFinanceReport])

  const prepareReport = async () => {
    setInsideLoading(true)

    let searchQuery = {
      financeReportId,
    }
    const params = serializeQuery(searchQuery)
    if (!!financeReportId) await onGetFinanceReportDetailList(params)
  }
  const approvedFinanceReport = async () => {
    setInsideLoading(true)
    await approved(financeReportId, openNotification).then(async x => {
      setInsideLoading(false)
      let searchQuery = {
        financeReportId,
      }
      const params = serializeQuery(searchQuery)
      await onGetFinanceReportDetailList(params)
      setFinanceDataApproved(!financeDataApproved)
    })
  }

  return (
    <>
      {loading && insideLoading && <Spin tip="Loading" size="large" />}

      <Row gutter={[8, 8]}>
        <Col>
          <FinanceReportList
            selectFinanceReport={setFinanceReportId}
            props={props}
          />
        </Col>
        <Col>
          <Switch
            checked={financeDataApproved}
            loading={insideLoading}
            onChange={approvedFinanceReport}
          />
        </Col>
      </Row>
      <Space />
      <Button
        htmlType="button"
        onClick={async () => {
          await prepareReport()
        }}
      >
        گزارش گیری
      </Button>

      {lstFinanceReportDetail.length > 0 ? (
        <div style={{ maxWidth: "822px" }} id="viewer"></div>
      ) : (
        "رکوردی برای نمایش وجود ندارد مجددا گزارش گیری نمایید"
      )}
    </>
  )
}

const mapStateToProps = ({ FinanceReport }) => ({
  lstFinanceReport: FinanceReport.lstFinanceReport,
  lstFinanceReportDetail: FinanceReport.lstFinanceReportDetail,
  error: FinanceReport.error,
  success: FinanceReport.success,
  loading: FinanceReport.loading,
})

const mapDispatchToProps = dispatch => ({
  onGetFinanceReport: () => dispatch(getFinanceReport()),
  onGetFinanceReportDetailList: searchValue =>
    dispatch(getFinanceReportDetailList(searchValue)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Report)
